const CommentsForm = {
	new_comment: 'New Comment',
	name: 'Name (optional)',
	submit: 'Submit'
}

export default CommentsForm;